var map = {
	"./story1.jpg": "ZFoh",
	"./story2.gif": "GTIs",
	"./story3.jpg": "hdxX",
	"./story4.gif": "2Q+J",
	"./story5.jpg": "sKAp",
	"./story6.jpg": "GVxf",
	"./story7.jpg": "/P/i",
	"./story8.jpg": "Jg62",
	"./story9.jpg": "jdpp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W37q";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main ^\.\/.*$
// module id = W37q
// module chunks = 0